import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ItemStatus } from '../../enums/item-status.enum';
import { ApplicationListDetail } from '../../../applications/model/application/application-list-detail.model';
import { ApplicationDetail } from '../../../applications/model/application/application-detail.model';

type ListType = ApplicationListDetail;
type DetailType = ApplicationListDetail | ApplicationDetail;

/**
 * Generic presentational component for application and card detail.
 * Application and card appearance is very similar so there is only one component. It emits a few events depending on ItemType
 * and ItemStatus.
 *
 * Differentiates between expanded and collapsed view. In case of collapsed it uses #item element. In case of expanded
 * state it uses #itemDetail.
 */
@Component({
    selector: 'ssf-list-item',
    template: require('./list-item.component.html'),
    styles: [require('./list-item.component.scss')]
})
export class ListItemComponent {
    public ItemStatus = ItemStatus; // so we can use ItemStatus enum in template, has to be public otherwise tslint complains

    @Input() shown: boolean;
    @Input() dirty: boolean;
    @Input() status: ItemStatus;
    @Input() item: ListType;
    @Input() itemDetail: DetailType;

    @Output() onItemClick = new EventEmitter<DetailType>();
    public i18n = 'SHARED.LIST-ITEM.';

    onToggle() {
        this.onItemClick.emit(this.item);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/list-item/list-item.component.ts